export interface Dictionary<T> {
  [key: string]: T
}

export enum Environment {
  development = 'development',
  testing = 'testing',
  staging = 'staging',
  production = 'production'
}

export enum AssetType {
  MenuTerm = 'MenuTerm',
  Page = 'Page',
  HotOrNot = 'HotOrNot',
  Poll = 'Poll',
  File = 'File',
  Comment = 'Comment',
  Collection = 'Collection',
  Video = 'Video',
  Profile = 'Profile',
  StructureTerm = 'StructureTerm',
  StructureTermTemplate = 'StructureTermTemplate',
  Article = 'Article',
  ArticleVersion = 'ArticleVersion',
  ArticleTemplate = 'ArticleTemplate',
  TeaserGroupTemplate = 'TeaserGroupTemplate',
  ImageDetail = 'ImageDetail',
  BlsItem = 'BlsItem',
  ErrorItem = 'ErrorItem',
  HoroscopeDay = 'HoroscopeDay',
  HoroscopeWeek = 'HoroscopeWeek',
  HoroscopeMonth = 'HoroscopeMonth',
  HoroscopeYear = 'HoroscopeYear',
  HoroscopeLove = 'HoroscopeLove',
  HoroscopeChild = 'HoroscopeChild',
  HoroscopeTarot = 'HoroscopeTarot',
  HoroscopeTarotDay = 'HoroscopeTarotDay',
  HoroscopeTarotWeek = 'HoroscopeTarotWeek',
  HoroscopeAngelTarot = 'HoroscopeAngelTarot',
  HoroscopeAngelTarotDay = 'HoroscopeAngelTarotDay',
  HoroscopeAngelTarotWeek = 'HoroscopeAngelTarotWeek',
  HoroscopeTendencies = 'HoroscopeTendencies',
  HoroscopeMoonCalendar = 'HoroscopeMoonCalendar',
  HoroscopeMoonRun = 'HoroscopeMoonRun',
  HoroscopeGuardianAngelMessage = 'HoroscopeGuardianAngelMessage',
  HistoryItem = 'HistoryItem',
  VideoChannel = 'VideoChannel',
  Recipe = 'Recipe',
  FeedConfig = 'FeedConfig'
}

export enum Brand {
  all = 'all',
  astrowoche = 'astrowoche',
  autozeitung = 'autozeitung',
  bravo = 'bravo',
  cosmopolitan = 'cosmopolitan',
  happinez = 'happinez',
  intouch = 'intouch',
  lecker = 'lecker',
  liebenswert = 'liebenswert',
  maennersache = 'maennersache',
  praxisvita = 'praxisvita',
  selbst = 'selbst',
  tvmovie = 'tvmovie',
  whitelabel = 'whitelabel',
  wunderweib = 'wunderweib',
  todaysgolfer = 'todaysgolfer'
}

export enum TeaserAutoType {
  structure = 'structure',
  author = 'author',
  related = 'related',
  query = 'query',
  newest = 'newest'
}

export enum PageableTeaserTypeEnum {
  filteredTeaserButton = 'FilteredTeaserButton'
}

export type NextProductionBrand = Exclude<Brand, 'all' | 'autozeitung' | 'selbst' | 'tvmovie' | 'whitelabel'>

// Asset statuses in asset.workflowMeta.status
export enum WorkFlowMetaStatus {
  new = 'new',
  review = 'review',
  approved = 'approved',
  published = 'published',
  unpublished = 'unpublished',
  rejected = 'rejected',
}

export type ApiKeyReference = { reference: string, apiKey: string }
export type ApiKeyMap = Map<Brand, string>
export type ApiKeyMapper = (brand: Brand) => string;
